import { Section } from '../common/Section'
import { Eyebrow } from '../common/Eyebrow'
import { Reveal } from '../animation/Reveal'
import { ProductCard } from './ProductCard'
import type { Product } from '../../types'

export function RelatedProducts({ products }: { products: Product[] }) {
  if (!products.length) return null
  return (
    <Section className="section bg-canvas" containerClassName="">
      <Eyebrow>Related products</Eyebrow>
      <h2 className="mt-4 font-display text-h1 font-semibold text-ink">More of the range</h2>
      <Reveal className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" stagger={0.1} y={26}>
        {products.map((p) => (
          <ProductCard key={p.slug} product={p} />
        ))}
      </Reveal>
    </Section>
  )
}
